import { render, staticRenderFns } from "./PlatformTermsAndConditions.vue?vue&type=template&id=07a90a82&scoped=true&"
import script from "./PlatformTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./PlatformTermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./PlatformTermsAndConditions.vue?vue&type=style&index=0&id=07a90a82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a90a82",
  null
  
)

export default component.exports